export default window.fetch;
